import type React from 'react';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageState } from '../components/PageState';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();
	const {
		data: { hideMediaSlot },
	} = usePsfPromoteOrSharePageData();

	return (
		<>
			{/* PageBanner on desktop only - on mobile it's inside parallax, except when the media slot is
			    hidden, where the parallax block is gone and the banner re-homes here on every viewport */}
			<div className={hideMediaSlot ? 'relative' : 'relative hidden md:block'}>
				<PageBanner />
			</div>
			<div className="bg-background-overlay min-h-screen w-full pb-16 md:pt-12">
				<PageState />
				<div className="mx-auto max-w-[610px]">
					<PageBody />
					<PageFooter />
				</div>
			</div>
		</>
	);
};
